/** Reload the page. Its own module so tests can stub it (jsdom cannot
 *  navigate, and `window.location.reload` cannot be spied on). */
export function reloadPage(): void {
  window.location.reload();
}
